/* MOOMZEE_CONFIGURATOR_FALLBACK_GUARD: Do not run custom configurator on fallback/non-metaobject products. */
(function () {
  function mzRunConfigurator() {
    if (document.querySelector('[data-mz-configurator-product="false"]')) return;
    document.addEventListener('DOMContentLoaded', function () {
    
      const dataEl = document.getElementById('mz-data');
      if (!dataEl) return;
    
      const data = JSON.parse(dataEl.textContent);
    
      // ================= GALLERY DATA =================
      const galleryData = JSON.parse(
        document.getElementById('mz-gallery-data')?.textContent || '[]'
      );
    
      let mainSwiper, thumbSwiper;
    
      let selected = {
        type: null,
        size: null,
        depth: null,
        frame: null,
        hardware: null
      };
    
      function updateSelectedConfig() {
        const els = document.querySelectorAll('.mz-selected-config');
        if (!els.length) return;
    
        const type = selected.type
          ? selected.type.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
          : '';
    
        const size = selected.size || '';
    
        const text = `Selected configuration: ${type}${size ? ' / ' + size : ''}`;
    
        els.forEach(el => {
          el.innerText = text;
        });
      }
    
      const typeEls = document.querySelectorAll('.mz-type');
      const sizeContainer = document.querySelector('.mz-size-grid');
      const depthContainer = document.querySelector('.mz-depth-options');
    
      const frameBlock = document.querySelector('.mz-frame-block');
      const depthBlock = document.querySelector('.mz-depth-block');
      const hardwareBlock = document.querySelector('.mz-hardware-block');
    
      function normalize(str) {
        return (str || '').toLowerCase().replace(/ /g, '_');
      }
    
      function matchType(value) {
        return normalize(value) === selected.type;
      }
    
      function getVariant() {
    
        return data.variants.find(v => {
    
          const typeMatch =
            normalize(v.option1) === normalize(selected.type);
    
          const sizeMatch =
            String(v.option2).trim() === String(selected.size).trim();
    
          const depthMatch =
            String(v.option3).trim() === String(selected.depth).trim() ||
            (v.option3 === 'no_depth' && !selected.depth);
    
          return typeMatch && sizeMatch && depthMatch;
        });
    
      }
    
      function initGallery() {
        thumbSwiper = new Swiper('.mz-thumbs', {
          direction: 'vertical',
          slidesPerView: 5,
          spaceBetween: 10,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          breakpoints: {
            0: {
              direction: 'horizontal',
              slidesPerView: 4, // 👈 center + side cuts
              // centeredSlides: true,
              spaceBetween: 20,
              // centeredSlidesBounds: true,
              loop: true,
              slidesOffsetBefore: 18, // The "padding" on the left of the first slide
              // slidesOffsetAfter: 30,  // The "padding" on the right of the last slide
            },
            600: {
              direction: 'vertical',
              slidesPerView: 5,
              centeredSlides: false,
              spaceBetween: 10,
              loop: false,
            }
          }
        });
    
        mainSwiper = new Swiper('.mz-main', {
          loop: true,
          spaceBetween: 10,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          thumbs: {
            swiper: thumbSwiper,
          },
        });
      }
    
      function updateGallery(images) {
        if (!mainSwiper || !thumbSwiper) return;
    
        mainSwiper.removeAllSlides();
        thumbSwiper.removeAllSlides();
    
        images.forEach(src => {
          mainSwiper.appendSlide(`
            <div class="swiper-slide">
              <img src="${src}" />
            </div>
          `);
    
          thumbSwiper.appendSlide(`
            <div class="swiper-slide">
              <img src="${src}" />
            </div>
          `);
        });
    
        mainSwiper.update();
        thumbSwiper.update();
      }
    
      function getTypeGallery() {
        return galleryData.find(t => t.type === selected.type);
      }
    
      let lightbox = null;
    
      function openLightbox() {
        const typeData = getTypeGallery();
        if (!typeData) return;
    
        let images = [];
    
        if (typeData.gallery && typeData.gallery.length) {
          images = typeData.gallery;
        } 
        else if (typeData.frames && typeData.frames.length) {
    
          if (selected.frame) {
            const frame = typeData.frames.find(
              f => f.handle === selected.frame.handle
            );
            images = frame?.images || [];
          } else {
            images = typeData.frames[0]?.images || [];
          }
        }
    
        if (!images.length) return;
    
        // destroy previous instance
        if (lightbox) {
          lightbox.destroy();
        }
    
        lightbox = GLightbox({
          elements: images.map(img => ({ href: img, type: 'image' })),
    
          // 👇 important options
          touchNavigation: true,
          loop: true,
          zoomable: true,
          draggable: true,
          openEffect: 'zoom',
          closeEffect: 'fade',
          slideEffect: 'fade',
    
        });
    
        // ✅ open at current swiper index
        const currentIndex = mainSwiper?.activeIndex || 0;
    
        lightbox.openAt(currentIndex);
      }
    
      document.querySelector('.mz-open-lightbox')?.addEventListener('click', openLightbox);

      function money(cents) {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
        }).format(Number(cents || 0) / 100);
      }

      function ensureCompareAtStyles() {
        if (document.getElementById('mz-configurator-compare-at-style')) return;

        const style = document.createElement('style');
        style.id = 'mz-configurator-compare-at-style';
        style.textContent = `
          .mz-price-box {
            align-items: baseline;
            display: flex;
            flex-wrap: wrap;
            gap: 8px 10px;
          }

          .mz-configurator-compare {
            color: #777;
            font-size: 18px;
            font-weight: 700;
            line-height: 1;
            text-decoration: line-through;
          }

          .mz-configurator-save {
            background: #000;
            color: #fff;
            display: inline-flex;
            font-size: 10px;
            font-weight: 800;
            letter-spacing: .08em;
            line-height: 1;
            padding: 5px 7px;
            text-transform: uppercase;
          }

          .mz-configurator-compare[hidden],
          .mz-configurator-save[hidden] {
            display: none !important;
          }
        `;
        document.head.appendChild(style);
      }

      function ensureCompareAtElements() {
        ensureCompareAtStyles();

        document.querySelectorAll('.mz-price-box').forEach(box => {
          if (!box.querySelector('[data-mz-configurator-compare]')) {
            const compare = document.createElement('span');
            compare.className = 'mz-configurator-compare';
            compare.setAttribute('data-mz-configurator-compare', '');
            compare.hidden = true;
            box.appendChild(compare);
          }

          if (!box.querySelector('[data-mz-configurator-save]')) {
            const save = document.createElement('span');
            save.className = 'mz-configurator-save';
            save.setAttribute('data-mz-configurator-save', '');
            save.hidden = true;
            box.appendChild(save);
          }
        });
      }

      function setTextAndHidden(el, text, hidden) {
        if (el.textContent !== text) el.textContent = text;
        if (el.hidden !== hidden) el.hidden = hidden;
      }

      function updateCompareAtDisplay(variant, displayPriceCents) {
        ensureCompareAtElements();

        const basePrice = Number(variant && variant.price || 0);
        const baseCompareAt = Number(variant && variant.compare_at_price || 0);
        const extraCents = Math.max(0, Number(displayPriceCents || 0) - basePrice);
        const displayCompareAt = baseCompareAt > basePrice ? baseCompareAt + extraCents : 0;
        const shouldShow = displayCompareAt > Number(displayPriceCents || 0);

        document.querySelectorAll('[data-mz-configurator-compare]').forEach(el => {
          setTextAndHidden(el, shouldShow ? money(displayCompareAt) : '', !shouldShow);
        });

        document.querySelectorAll('[data-mz-configurator-save]').forEach(el => {
          if (!shouldShow) {
            setTextAndHidden(el, '', true);
            return;
          }

          const savePercent = Math.max(1, Math.round(((displayCompareAt - displayPriceCents) * 100) / displayCompareAt));
          setTextAndHidden(el, 'Save ' + savePercent + '%', false);
        });
      }
    
      function updatePrice() {
        const v = getVariant();
        if (!v) {
          updateCompareAtDisplay(null, 0);
          return;
        }
    
        let price = v.price / 100;
    
        if (selected.hardware) {
          price += parseFloat(selected.hardware.price || 0);
        }
    
        document.querySelectorAll('.mz-price').forEach(el => {
          el.innerText = '$' + price.toFixed(2);
        });

        updateCompareAtDisplay(v, Math.round(price * 100));
    
        // ✅ IMPORTANT: sync Shopify form variant
        const variantInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
        if (variantInput) {
          variantInput.value = v.id;
        }
    
        // const url = new URL(window.location.href);
        // url.searchParams.set('variant', v.id);
        // window.history.replaceState({}, '', url);
    
    
      }
    
      function loadSizeGroups(typeData) {
    
        const groupContainer = document.querySelector('.mz-size-groups');
        const sizeContainer = document.querySelector('.mz-size-grid');
    
        groupContainer.innerHTML = '';
        sizeContainer.innerHTML = '';
    
        const groups = [
          { label: 'Small', sizes: typeData.small_sizes || [] },
          { label: 'Medium', sizes: typeData.medium_sizes || [] },
          { label: 'Large', sizes: typeData.large_sizes || [] }
        ];
    
        groups.forEach(group => {
    
          // ❌ skip empty groups
          if (!group.sizes.length) return;
    
          const btn = document.createElement('button');
          btn.innerText = group.label;
    
          btn.onclick = () => {
    
            document.querySelectorAll('.mz-size-groups button')
              .forEach(b => b.classList.remove('active'));
    
            btn.classList.add('active');
    
            sizeContainer.innerHTML = '';
    
            group.sizes.forEach(size => {
    
              // ✅ validate against variants (VERY IMPORTANT)
              const exists = data.variants.some(v =>
                normalize(v.option1) === selected.type &&
                String(v.option2).trim() === String(size).trim()
              );
    
              if (!exists) return;
    
              const sizeBtn = document.createElement('button');
              sizeBtn.innerText = size;
    
              sizeBtn.onclick = () => {
                selected.size = size;
    
                document.querySelectorAll('.mz-size-grid button')
                  .forEach(b => b.classList.remove('active'));
    
                sizeBtn.classList.add('active');
    
                updatePrice();
                updateSelectedConfig();
              };
    
              sizeContainer.appendChild(sizeBtn);
            });
    
            // auto select first size
            const firstSize = sizeContainer.querySelector('button');
            if (firstSize) firstSize.click();
          };
    
          groupContainer.appendChild(btn);
        });
    
        // auto select first group
        const firstGroup = groupContainer.querySelector('button');
        if (firstGroup) firstGroup.click();
      }
    
      function loadDepth() {
        depthContainer.innerHTML = '';
    
        const depths = new Set();
    
        data.variants.forEach(v => {
          if (matchType(v.option1)) {
            depths.add(v.option3);
          }
        });
    
        depths.forEach(d => {
          if (d && d !== 'no_depth') {
            const btn = document.createElement('button');
            btn.innerText = d;
    
            btn.onclick = () => {
              selected.depth = d;
    
              document.querySelectorAll('.mz-depth-options button').forEach(b => b.classList.remove('active'));
              btn.classList.add('active');
    
              updatePrice();
            };
    
            depthContainer.appendChild(btn);
          }
        });
      }
    
      function loadHardware(typeData) {
    
        const hardwareContainer = document.querySelector('.mz-hardware');
        hardwareContainer.innerHTML = '';
    
        if (!typeData.hardware_options || !typeData.hardware_options.length) return;
    
        typeData.hardware_options.forEach(handle => {
    
          const h = data.hardware.find(item => item.handle_name === handle);
    
          if (!h) return;
    
          const btn = document.createElement('button');
          btn.classList.add('mz-hardware-btn');
    
          btn.innerText = h.name;
          btn.dataset.handle = h.handle_name;
          btn.dataset.price = h.price;
    
          btn.onclick = () => {
    
            document.querySelectorAll('.mz-hardware-btn').forEach(b => b.classList.remove('active'));
    
            btn.classList.add('active');
    
            selected.hardware = {
              handle: h.handle_name,
              name: h.name,
              price: parseFloat(h.price || 0),
              variant_id: h.variant_id || null
            };
    
            updatePrice();
          };
    
          hardwareContainer.appendChild(btn);
        });
    
        // auto select first
        const first = hardwareContainer.querySelector('button');
        if (first) first.click();
      }
    
      function autoSelectFrame() {
        const firstVisible = [...document.querySelectorAll('.mz-frame')]
          .find(el => el.style.display !== 'none');
    
        if (firstVisible) firstVisible.click();
      }
    
      function filterUI() {
    
        const typeData = data.productTypes.find(t => t.handle_name === selected.type);
        if (!typeData) return;
    
        frameBlock.style.display = typeData.has_frame_color ? 'block' : 'none';
        depthBlock.style.display = typeData.has_depth ? 'block' : 'none';
        hardwareBlock.style.display = typeData.has_hardware ? 'block' : 'none';
    
        // FRAME FILTER
        document.querySelectorAll('.mz-frame').forEach(el => {
    
          const types = (el.dataset.types || '')
            .toLowerCase()
            .split(',')
            .map(t => t.trim());
    
          el.style.display = types.includes(selected.type) ? 'block' : 'none';
        });
    
        loadSizeGroups(typeData);
        loadDepth();
        loadHardware(typeData);
    
        setTimeout(() => {
    
          const firstSize = sizeContainer.querySelector('button');
          if (firstSize) firstSize.click();
    
          const firstDepth = depthContainer.querySelector('button');
          if (firstDepth) firstDepth.click();
    
          // ✅ AUTO SELECT FRAME
          autoSelectFrame();
          updateSelectedConfig();
    
        }, 100);
      }
    
      // TYPE CLICK
      typeEls.forEach(el => {
        el.onclick = () => {
    
          selected = {
            type: el.dataset.type,
            size: null,
            depth: null,
            frame: null,
            hardware: null
          };
    
          updateSelectedConfig();
    
          typeEls.forEach(t => t.classList.remove('active'));
          el.classList.add('active');
    
          filterUI();
    
          // ================= GALLERY UPDATE =================
          const typeData = getTypeGallery();
    
          if (typeData) {
    
            if (typeData.gallery && typeData.gallery.length) {
              // non-frame product
              updateGallery(typeData.gallery);
            }
            else if (typeData.frames && typeData.frames.length) {
              // frame product → load first frame gallery
              updateGallery(typeData.frames[0].images || []);
            }
    
            // ✅ show/hide frame block
            if (!typeData.frames.length) {
              frameBlock.style.display = 'none';
            } else {
              frameBlock.style.display = 'block';
            }
          }
    
          // ✅ reset frame
          selected.frame = null;
    
          const typeMap = {
            canvas_art: '.canvas-art-features',
            framed_canvas: '.framed-canvas-features',
            framed_art: '.framed-art-features',
            fine_art_paper: '.fine-art-paper-features',
            large_wall_art: '.large-wall-art-features',
            metal_prints: '.metal-prints-features'
          };
    
          // hide all feature sections
          document.querySelectorAll('[class$="-features"]').forEach(item => {
            item.style.display = 'none';
          });
    
          // show only matching
          const selector = typeMap[el.dataset.type];
          if (selector) {
            document.querySelectorAll(selector).forEach(item => {
              item.style.display = 'block';
            });
          }
    
          const faqTypeMap = {
            canvas_art: '.canvas-art-faq',
            framed_canvas: '.framed-canvas-faq',
            framed_art: '.framed-art-faq',
            fine_art_paper: '.fine-art-paper-faq',
            large_wall_art: '.large-wall-art-faq',
            metal_prints: '.metal-prints-faq'
          };
    
          // hide all FAQ sections
          document.querySelectorAll('[class$="-faq"]').forEach(item => {
            item.style.display = 'none';
          });
    
          // show only matching FAQ
          const faqSelector = faqTypeMap[el.dataset.type];
          if (faqSelector) {
            document.querySelectorAll(faqSelector).forEach(item => {
              item.style.display = 'block';
            });
          }
          
    
    
        };
      });
    
      // FRAME CLICK
      document.querySelectorAll('.mz-frame').forEach(el => {
        el.onclick = () => {
    
          document.querySelectorAll('.mz-frame').forEach(e => {
            if (e.style.display !== 'none') e.classList.remove('active');
          });
    
          el.classList.add('active');
    
          selected.frame = {
            handle: el.dataset.handle,
            name: el.dataset.name
          };
    
          const typeData = getTypeGallery();
          if (!typeData) return;
    
          console.log('selected:', selected.frame.handle);
          console.log('frames:', typeData.frames);
          const frame = typeData.frames.find(
            f => f.handle === selected.frame.handle
          );
    
          if (!frame || !frame.images) return;
    
          // replace entire gallery
          updateGallery(frame.images);
    
          console.log(frame.images);
    
    
        };
      });
    
      // ADD TO CART
      document.querySelectorAll('.mz-add').forEach(btn => {
          btn.onclick = async () => {
    
          const variant = getVariant();
    
          if (!variant) {
            alert('Please select valid combination');
            return;
          }
    
          const items = [
            {
              id: variant.id,
              quantity: 1,
              properties: {
                "Frame": selected.frame?.name || 'No Frame',
                "Hardware": selected.hardware?.name || ''
              }
            }
          ];
    
          // ✅ ADD HARDWARE PRODUCT
          if (selected.hardware && selected.hardware.variant_id) {
            items.push({
              id: selected.hardware.variant_id,
              quantity: 1
            });
          }
    
          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ items })
            });
    
            if (!res.ok) {
              const err = await res.json();
              alert(err.description || 'Error adding to cart');
              return;
            }
    
            window.location.href = '/cart';
    
          } catch (e) {
            console.error(e);
            alert('Something went wrong');
          }
        };
      });
    
      // ✅ AUTO SELECT CHEAPEST FRONT-END VARIANT ON LOAD
      const defaultType = document.querySelector('.mz-type[data-type="fine_art_paper"]');
      if (defaultType) defaultType.click();
    
      initGallery();
    
      setTimeout(() => {
        const defaultType = document.querySelector('.mz-type[data-type="fine_art_paper"]');
        if (defaultType) defaultType.click();
      }, 50);
    
    
    });
    
    

  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mzRunConfigurator, { once: true });
  } else {
    mzRunConfigurator();
  }
})();


/* MOOMZEE_SELECTED_PRODUCT_TYPE_GALLERY_FIT
   Adds selected product type state for CSS-only gallery fit changes.
   Scoped to configurator products; old-product fallback gallery is ignored.
*/
(function () {
  if (window.__moomzeeSelectedProductTypeGalleryFitBound) return;
  window.__moomzeeSelectedProductTypeGalleryFitBound = true;

  function normalizeType(value) {
    const text = String(value || '').trim().toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
    if (!text) return '';
    if (text.includes('framed canvas')) return 'framed_canvas';
    if (text.includes('framed art')) return 'framed_art';
    if (text.includes('canvas art')) return 'canvas_art';
    if (text.includes('fine art paper')) return 'fine_art_paper';
    if (text.includes('large wall art')) return 'large_wall_art';
    if (text.includes('metal print')) return 'metal_prints';
    return text.replace(/\s+/g, '_');
  }

  function buttonText(node) {
    if (!node) return '';
    return node.getAttribute('data-product-type')
      || node.getAttribute('data-product-type-handle')
      || node.getAttribute('data-handle')
      || node.getAttribute('data-value')
      || node.getAttribute('aria-label')
      || node.textContent
      || '';
  }

  function findSelectedProductType(root) {
    const selectors = [
      '[data-product-type][aria-pressed="true"]',
      '[data-product-type].active',
      '[data-product-type].is-active',
      '[data-product-type][aria-current="true"]',
      '[data-product-type-handle][aria-pressed="true"]',
      '[data-product-type-handle].active',
      '[data-product-type-handle].is-active',
      '[aria-pressed="true"]',
      '.active',
      '.is-active',
      '[aria-current="true"]'
    ];

    for (const selector of selectors) {
      const candidates = Array.from(root.querySelectorAll(selector));
      for (const candidate of candidates) {
        const type = normalizeType(buttonText(candidate));
        if (type) return type;
      }
    }

    const text = root.textContent || '';
    if (/framed\s+canvas/i.test(text) && /framed\s+canvas/i.test(document.activeElement && document.activeElement.textContent || '')) return 'framed_canvas';
    if (/framed\s+art/i.test(text) && /framed\s+art/i.test(document.activeElement && document.activeElement.textContent || '')) return 'framed_art';
    return '';
  }

  function updateSelectedProductType() {
    const wrappers = Array.from(document.querySelectorAll('[data-mz-configurator-product="true"]'));
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      const selected = findSelectedProductType(wrapper);
      if (selected) {
        wrapper.setAttribute('data-selected-product-type', selected);
        document.documentElement.setAttribute('data-mz-selected-product-type', selected);
      }
    });
  }

  document.addEventListener('click', function () {
    window.requestAnimationFrame(updateSelectedProductType);
    setTimeout(updateSelectedProductType, 80);
  }, true);
  document.addEventListener('change', function () {
    window.requestAnimationFrame(updateSelectedProductType);
    setTimeout(updateSelectedProductType, 80);
  }, true);
  document.addEventListener('DOMContentLoaded', updateSelectedProductType, { once: true });
  document.addEventListener('shopify:section:load', updateSelectedProductType);
  if (document.readyState !== 'loading') updateSelectedProductType();

  const observer = new MutationObserver(function () {
    window.requestAnimationFrame(updateSelectedProductType);
  });
  observer.observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['class', 'aria-pressed', 'aria-current'] });
})();
